import React from 'react';
import { TeamMember } from '../types';

interface TeamCardProps {
  member: TeamMember;
  showBio?: boolean;
  index?: number;
}

const TeamCard: React.FC<TeamCardProps> = ({ member, showBio = true, index }) => {
  return (
    <div
      className="card team-card"
      data-cms-index={index}
    >
      <img
        src={member.image}
        alt={member.name}
        className="card-image"
        data-cms-field="team"
        data-cms-index={index}
        data-cms-item-field="image"
        data-cms-type="image"
      />
      <div className="card-content">
        <h3 data-cms-field="team" data-cms-index={index} data-cms-item-field="name">{member.name}</h3>
        <p className="role" data-cms-field="team" data-cms-index={index} data-cms-item-field="role">{member.role}</p>
        <div className="contact-info">
          <a href={`mailto:${member.email}`} data-cms-field="team" data-cms-index={index} data-cms-item-field="email">{member.email}</a>
          {member.phone && <a href={`tel:${member.phone.replace(/\D/g, '')}`} data-cms-field="team" data-cms-index={index} data-cms-item-field="phone">{member.phone}</a>}
        </div>
        {showBio && member.bio && <p className="bio" data-cms-field="team" data-cms-index={index} data-cms-item-field="bio">{member.bio}</p>}
      </div>
    </div>
  );
};

export default TeamCard;
